import { Navigate, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import SideNavigationBar from "../../components/sideNavigationBar/SideNavigationBar";
import Dashboard from "../../views/dashboard/Dashboard";

import { useEffect, useRef, useState } from "react";

import { classNames, withRouter } from "../../shared/utility";
import MyAccount from "../../views/myAccount/MyAccount";

import HeaderLayout from "./HeaderLayout";
import Products from "../../views/setup/products/Products";
import TraceabilityScreen from "../../views/traceability/TraceabilityScreen";
import Assistant from "../../views/assistant/Assistant";
import Allergens from "../../views/setup/allergens/Allergens";
import BoxTypes from "../../views/setup/boxTypes/BoxTypes";
import Carriers from "../../views/setup/carriers/Carriers";
import Categories from "../../views/setup/categories/Categories";
import Classes from "../../views/setup/classes/Classes";
import Customers from "../../views/setup/customers/Customers";
import CustomerTypes from "../../views/setup/customerTypes/CustomerTypes";
import Locations from "../../views/setup/locations/Locations";
import ReasonCodes from "../../views/setup/reasonCodes/reasonCodes";
import Suppliers from "../../views/setup/suppliers/Suppliers";
import Users from "../../views/setup/users/Users";
import WeighingUsers from "../../views/setup/weighingUsers/WeighingUsers";
import Warehouses from "../../views/setup/warehouses/Warehouses";
import WarehouseDetails from "../../views/setup/warehouses/WarehouseDetails";
import AddProduct from "../../views/setup/products/product/AddProductScreen";
import InventoryTypes from "../../views/setup/inventoryTypes/InventoryTypes";
import ProductDetailsScreen from "../../views/setup/products/product/ProductDetailsScreen";
import Currencies from "../../views/setup/currencies/Currencies";
import ReceivingInvoices from "../../views/receiving/ReceivingInvoices";
import AddReceivingInvoice from "../../views/receiving/AddReceivingInvoice";
import ReceivingInvoiceDetails from "../../views/receiving/ReceivingInvoiceDetails";
import Graphics from "../../views/setup/graphics/Graphics";
import Rooms from "../../views/setup/rooms/Rooms";
import Wips from "../../views/wips/Wips";
import CreateWip from "../../views/wips/CreateWip";
import WipDetails from "../../views/wips/WipDetails";
import { Toast } from "primereact/toast";
import Stations from "../../views/setup/stations/Stations";
import BarcodeHistoryScreen from "../../views/traceability/BarcodeHistoryScreen";
import Orders from "../../views/orders/Orders";
import OrderDetails from "../../views/orders/OrderDetails";
import CycleCounts from "../../views/cycleCounts/CycleCounts";
import CycleCountDetails from "../../views/cycleCounts/CycleCountDetails";
import QaReports from "../../views/qaReports/QaReports";
import Inventory from "../../views/inventory/Inventory";
import Laboratories from "../../views/setup/laboratories/Laboratories";
import ManualLabours from "../../views/setup/manualLabours/ManualLabours";
import TaxRates from "../../views/setup/taxRates/TaxRates";
import InventoryHistory from "../../views/inventoryHistory/InventoryHistory";
import SpecSheetTests from "../../views/setup/specSheetTests/SpecSheetTests";
import ClassDetails from "../../views/setup/classes/ClassDetails";
import LabSamples from "../../views/labSamples/LabSamples";
import LabSampleDetails from "../../views/labSamples/LabSampleDetails";
import LowInventory from "../../views/lowInventory/LowInventory";
import ProductColours from "../../views/setup/productColours/ProductColours";
import ProductOdours from "../../views/setup/productOdours/ProductOdours";
import ProductTastes from "../../views/setup/productTastes/ProductTastes";
import MissingInventory from "../../views/missingInventory/MissingInventory";
import CreditReturns from "../../views/creditReturns/CreditReturns";
import CreditReturnDetails from "../../views/creditReturns/CreditReturnDetails";
import ReceiptsScreen from "../../views/receipts/ReceiptsScreen";
import {
  EntityAuditPage,
  EntityTypeAuditPage,
} from "../../views/audit/AuditPage";

function DefaultLayout(props) {
  const {
    logout,
    user_type,
    user_id,
    snackbarQueue,
    removeSnackbar,
    showLowStockWarning,
  } = props;
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const size = useWindowSize();
  const toast = useRef(null);

  useEffect(() => {
    snackbarQueue.forEach((snackbar) => {
      toast.current.show({
        severity: "success",
        summary: snackbar.message,
        content: null,
        life: 3000,
      });
      removeSnackbar(snackbar.id);
    });
  }, [snackbarQueue]);

  useEffect(() => {
    if (size.width < 991) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
    }
  }, [size]);

  const outsideClickRef = useRef(null);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (
        outsideClickRef.current &&
        !outsideClickRef.current.contains(event.target) &&
        size.width < 991
      ) {
        setSidebarOpen(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [outsideClickRef, size]);

  return (
    <div
      className={classNames(
        sidebarOpen
          ? size.width < 991
            ? "scroll-blocked layout-mobile-active"
            : ""
          : "layout-static-inactive",
        "layout-container layout-static layout-light",
      )}
    >
      <SideNavigationBar
        user_type={user_type}
        user_id={user_id}
        outsideClickRef={outsideClickRef}
      />
      <Toast ref={toast} />
      <div className="layout-content-wrapper">
        <div className="layout-mask"></div>
        <HeaderLayout
          sidebarOpen={sidebarOpen}
          logout={logout}
          setSidebarOpen={setSidebarOpen}
          showLowStockWarning={showLowStockWarning}
        />

        <Routes>
          <Route
            path="/dashboard"
            element={
              Number(user_id) === 1 ? (
                <Dashboard logout={logout} />
              ) : (
                <main className="min-h-screen bg-slate-100" aria-hidden />
              )
            }
          />

          <Route path="/allergens" element={<Allergens />} />

          <Route path="/my-account" element={<MyAccount />} />

          <Route path="/box-types" element={<BoxTypes />} />
          <Route path="/carriers" element={<Carriers />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/classes/:id" element={<ClassDetails />} />
          <Route path="/currencies" element={<Currencies />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/customer-types" element={<CustomerTypes />} />
          <Route path="/graphics" element={<Graphics />} />
          <Route path="/inventory-types" element={<InventoryTypes />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/products/new" element={<AddProduct />} />
          <Route path="/products" element={<Products />} />
          <Route
            path="/products/:productId"
            element={<ProductDetailsScreen />}
          />
          <Route path="/reason-codes" element={<ReasonCodes />} />
          <Route path="/rooms" element={<Rooms />} />
          <Route path="/stations" element={<Stations />} />
          <Route path="/suppliers" element={<Suppliers />} />
          <Route path="/users" element={<Users />} />
          <Route path="/weighing-users" element={<WeighingUsers />} />
          <Route path="/warehouses" element={<Warehouses />} />
          <Route
            path="/warehouses/:warehouseId"
            element={<WarehouseDetails />}
          />

          <Route path="/receiving" element={<ReceivingInvoices />} />
          <Route path="/receiving/new" element={<AddReceivingInvoice />} />
          <Route
            path="/receiving/:receivingId"
            element={<ReceivingInvoiceDetails />}
          />

          <Route path="/wips" element={<Wips />} />
          <Route path="/wips/new" element={<CreateWip />} />
          <Route path="/wips/:wipId" element={<WipDetails />} />

          <Route path="/traceability" element={<TraceabilityScreen />} />
          <Route path="/barcode-history" element={<BarcodeHistoryScreen />} />
          <Route path="/assistant" element={<Assistant />} />

          <Route path="/shipments" element={<Orders />} />
          <Route path="/shipments/:orderId" element={<OrderDetails />} />
          {/* <Route path="/orders/new" element={<CreateOrder />} /> */}
          <Route path="/credit-returns" element={<CreditReturns />} />
          <Route
            path="/credit-returns/:creditReturnId"
            element={<CreditReturnDetails />}
          />

          <Route path="/cycle-counts" element={<CycleCounts />} />
          <Route
            path="/cycle-counts/:cycleCountId"
            element={<CycleCountDetails />}
          />

          <Route path="/qa-reports" element={<QaReports />} />

          <Route path="/inventory" element={<Inventory />} />

          <Route path="/inventory-history" element={<InventoryHistory />} />

          <Route path="/laboratories" element={<Laboratories />} />

          <Route path="/manual-labours" element={<ManualLabours />} />

          <Route path="/tax-rates" element={<TaxRates />} />

          <Route path="/spec-sheet-tests" element={<SpecSheetTests />} />

          <Route path="/lab-samples" element={<LabSamples />} />
          <Route path="/lab-samples/:id" element={<LabSampleDetails />} />

          <Route path="/low-in-stock" element={<LowInventory />} />
          <Route path="/missing-stock" element={<MissingInventory />} />

          <Route path="/product-colours" element={<ProductColours />} />
          <Route path="/product-odours" element={<ProductOdours />} />
          <Route path="/product-tastes" element={<ProductTastes />} />

          <Route path="/receipts" element={<ReceiptsScreen />} />

          <Route
            path="/audit-histories/:entityType"
            element={<EntityTypeAuditPage />}
          />
          <Route
            path="/audit/:entityType/:entityId"
            element={<EntityAuditPage />}
          />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user_type: state.auth.user_type,
    user_id: state.auth.id,
    snackbarQueue: state.utilities.snackbarQueue,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    removeSnackbar: (snackbarId) =>
      dispatch(actions.removeSnackbar(snackbarId)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DefaultLayout),
);

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}
